// src/services/api.js
import axios from 'axios';
import { isTokenExpired, clearExpiredTokens } from '../utils/tokenUtils';

// Base API URL - change this based on environment
const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080/api';

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - Add JWT token and validate before sending
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    
    if (token) {
      // ⭐ CHECK IF TOKEN IS EXPIRED BEFORE SENDING REQUEST
      if (isTokenExpired(token)) {
        console.log('Token expired - clearing and redirecting to login');
        
        // Clear expired token
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        
        // Redirect to login
        window.location.href = '/login?expired=true';
        
        // Cancel the request
        return Promise.reject(new Error('Token expired'));
      }
      
      // Token is valid - add to headers
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle errors globally
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized - token expired or invalid
    if (error.response?.status === 401) {
      console.log('401 Unauthorized - clearing tokens');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login?expired=true';
    }
    
    // Handle 403 Forbidden - might be expired token
    if (error.response?.status === 403) {
      const token = localStorage.getItem('token');
      
      // If we have a token and it's expired, clear and redirect
      if (token && isTokenExpired(token)) {
        console.log('403 with expired token - clearing and redirecting');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login?expired=true';
      }
    }
    
    // Handle other errors
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred';
    console.error('API Error:', errorMessage);
    
    return Promise.reject(error);
  }
);

export default api;